import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  getRequest,
  post
} from 'helpers/RequestUtil'

import T from 'i18n-react'

import {
  UPDATE_ACTIVE_ADD_DIALOG
} from 'containers/Admin/PartnerSite/PartnerSite/constants'

import {
  POST_PARTNER_SITE, FETCH_PARTNER_SITES
} from './constants'

import {
  partnerSiteSelector,
  segmentSelector,
  lineSelector,
  partnerNameSelector,
  odmSelector,
  aeRegionSelector,
  customerClassSelector
} from './selectors'

import {
  siteRolesChanges,
} from 'containers/Admin/PartnerSite/PartnerSiteRole/selectors'

import {
  fetchPartnerSitesStart,
  fetchPartnerSitesSuccess,
  fetchPartnerSitesError,
  postPartnerSiteStart,
  postPartnerSiteSuccess,
  postPartnerSiteError,
  updatePartnerSiteList,
  fetchSegmentLineStart,
  fetchSegmentLineSuccess,
  fetchSegmentLineError,
  fetchAeRegionListStart,
  fetchAeRegionListSuccess,
  fetchAeRegionListError,
  updateSegmentList,
  updateLineList,
  updateAeRegionList
} from './actions'
import { success, error } from 'containers/App/Notification/actions'

function* fetchSegmentLines() {
  try {
    yield put(fetchSegmentLineStart())
    const data = yield call(getRequest, '/api/fulcrum/admin/segment_and_line')
    yield put(fetchSegmentLineSuccess())
    return data
  } catch(error) {
    yield put(fetchSegmentLineError(error))
  }
}

function* fetchAeRegionList() {
  try {
    yield put(fetchAeRegionListStart())
    const data = yield call(getRequest, '/api/fulcrum/admin/ae_regions')
    yield put(fetchAeRegionListSuccess())
    return data
  } catch(error) {
    yield put(fetchAeRegionListError(error))
  }
}

function* fetchPartnerSites(segment, line) {
  try {
    yield put(fetchPartnerSitesStart())
    const data = yield call(getRequest, `/api/fulcrum/admin/partner_sites?segment=${segment}&line=${line}`)
    yield put(fetchPartnerSitesSuccess())
    return data
  } catch(error) {
    yield put(fetchPartnerSitesError(error))
  }
}

function* postPartnerSite(partnerSite, segment, line, partnerName, odm, customerClass, aeRegion, team) {
  try {
    yield put(postPartnerSiteStart())
    const postRequest = post('partner_sites', { partnerSite, segment, line, partnerName, odm, customerClass, aeRegion, team })
    yield call(postRequest, '/api/fulcrum/admin/partner_sites')
    yield put(postPartnerSiteSuccess())
    yield put(success(T.translate('pages.admin.partnerSites.notification.create_post_success', { name: partnerSite } )))
  } catch(e) {
    yield put(postPartnerSiteError(e))
    // yield put(error(T.translate('pages.admin.partnerSites.notification.create_post_error', { name: partnerSite })))
  }
}

function* handleFetchSegmentLine() {
  let data = yield call(fetchSegmentLines)
  let segment = data.segments
  let line = data.lines
  yield put(updateSegmentList(segment))
  yield put(updateLineList(line))
}

function* handleFetchAeRegionList() {
  let data = yield call(fetchAeRegionList)
  yield put(updateAeRegionList(data))
}

function* handleFetchPartnerSites(action) {
  const { segment, line } = action
  let data = yield call(fetchPartnerSites, segment, line)
  let partner_sites = data.partnerSites
  yield put(updatePartnerSiteList(partner_sites))
}

function* handlePostSiteRoles() {
  const partnerSite = yield select(partnerSiteSelector)
  const segment = yield select(segmentSelector)
  const line = yield select(lineSelector)
  const partnerName = yield select(partnerNameSelector)
  const odm = yield select(odmSelector)
  const customerClass = yield select(customerClassSelector)
  const aeRegion = yield select(aeRegionSelector)
  const team = yield select(siteRolesChanges)
  yield call(postPartnerSite, partnerSite, segment, line, partnerName, odm, customerClass, aeRegion, team)
}

function* watchAddPartnerSite() {
  yield takeLatest(UPDATE_ACTIVE_ADD_DIALOG, handleFetchSegmentLine)
  yield takeLatest(UPDATE_ACTIVE_ADD_DIALOG, handleFetchAeRegionList)
}

function* watchFetchPartnerSites() {
  yield takeLatest(FETCH_PARTNER_SITES, handleFetchPartnerSites)
}

function* watchPostPartnerSite() {
  yield takeEvery(POST_PARTNER_SITE, handlePostSiteRoles)
}

function* loadSagas() {
  yield all([
    fork(watchAddPartnerSite),
    fork(watchFetchPartnerSites),
    fork(watchPostPartnerSite),
  ])
}

export default loadSagas
